module.exports = __webpack_public_path__ + "static/media/invite-expired.6fd07a99.svg";